<template>
   <div class="button-last-registration-container">
   <div class="selector">
      <ion-list>
        <ion-item>
          <ion-select
            aria-label="CheckOut Type"
            interface="popover"
            :placeholder="checkOutTypes.length ? 'Select CheckOut Type' : 'No types available'"
            v-model="selectedCheckOutType"
            :disabled="!checkOutTypes.length"
          >
            <ion-select-option
              v-for="option in checkOutTypes"
              :key="option.id"
              :value="option.type"
            >
              {{ option.type }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </div>
   
      <elapsed-time-check-in-out></elapsed-time-check-in-out>
      
      <ion-button shape="round" color="primary" @click="handleCheckOut">
        CHECK OUT
      </ion-button>
      <check-in-out-last-registration></check-in-out-last-registration>
    </div>
</template>


<script>
import { IonButton, IonItem, IonList, IonSelect, IonSelectOption } from "@ionic/vue";
import { defineComponent, ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import CheckInOutLastRegistration from "./CheckInOutLastRegistration.vue";
import ApiService from "../../common/service.api";
import ElapsedTimeCheckInOut from "./ElapsedTimeCheckInOut.vue";

export default defineComponent({
  components: {
    IonButton,
    CheckInOutLastRegistration,
    ElapsedTimeCheckInOut,
    IonItem,
    IonList,
    IonSelect,
    IonSelectOption,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const isLoading = ref(false);
    const checkOutTypes = ref([]);
    const selectedCheckOutType = ref(null);
    const idElement = ref(null);
    const fetchData = async () => {
      try {
        const route = useRoute();
        const { id } = route.params;
        console.log('id chekout' , id)
        console.log('parametro chekout', route.params)
        const journeyResponse = await ApiService.get(`Journey/Get/${id}`);
        console.log('journey checkoutcampaign' ,journeyResponse)
          idElement.value = journeyResponse.data[0]?.children[0].idElement;
        if (!idElement.value) {
          console.error("idElement was not found");
          return;
        }
        const checkInOutResponse = await ApiService.get(`CheckInOut/Get/${idElement.value}`);

        const typesWithId2 = checkInOutResponse.data.idsType.filter((item) => item.id === 2);
        checkOutTypes.value = typesWithId2;
      } catch (error) {
        console.error("error fetching data:", error);
      }
    };

    const handleCheckOut = async () => {
      const campaignId = route.params.id;
      isLoading.value = true;

      const payload = {
        id: 0,
        idCheckInOut: 0,
        idUser: store.getters["user/getUserData"].id,
        idType: 2,
        type: selectedCheckOutType.value,
        eventDate: new Date().toISOString(),
        note: "",
        geofencing: "",
      };

      try {
        const response = await ApiService.post("UserCheckInOut/Add", payload);

        router.push(`/campaign-journey/${campaignId}/check-in`);
      } catch (error) {
        console.error("Error al realizar el Check Out:", error);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      fetchData();
    });

    return {
      handleCheckOut,
      isLoading,
      checkOutTypes,
      selectedCheckOutType,
    };
  },
});
</script>

<style scoped>
.selector {
  margin-top: 20px;
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
}

.button-last-registration-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
</style>
